import {
    getRolesWithPermissions,
    getPermissions,
    assignRolePermissions,
} from "services/company/role/rolePermissionService";

import {
    rolePermissionStart,
    rolePermissionSuccess,
    rolePermissionFailure,
    updateRolePermissions,
} from "./rolePermissionSlice";

import {
    showSuccessToast,
    showErrorToast,
} from "utils/toastNotification";

export const fetchRolePermissionsData = () => async (dispatch) => {
    try {
        dispatch(rolePermissionStart());

        const [rolesRes, permissionsRes] = await Promise.all([
            getRolesWithPermissions(),
            getPermissions(),
        ]);

        dispatch(
            rolePermissionSuccess({
                roles: rolesRes.data || [],
                permissions: permissionsRes.data || [],
            })
        );
    } catch (error) {
        dispatch(rolePermissionFailure(error.message));
    }
};

export const saveRolePermissions =
    (roleId, permissionIds) => async (dispatch) => {
        try {
            const payload = {
                role_id: roleId,
                permissionIds,
            };

            const response = await assignRolePermissions(payload);

            if (response?.meta?.status) {
                dispatch(
                    updateRolePermissions({
                        roleId,
                        permissionIds,
                    })
                );

                showSuccessToast(
                    response?.meta?.message ||
                    "Permissions updated successfully"
                );
            }
        } catch (error) {
            showErrorToast(
                error?.response?.data?.meta?.message ||
                "Failed to update permissions"
            );
        }
    };